import { Box, ButtonBase, Typography, alpha, useTheme } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

interface BuildNewProductCardProps {
    onClick: () => void;
    title?: string;
    description?: string;
}

const BuildNewProductCard = ({
    onClick,
    title = "Build a new Product",
    description = "Work with our Agentic agent to organize and build your next amazing product."
}: BuildNewProductCardProps) => {
    const theme = useTheme();
    const primary = theme.palette.primary.main;

    return (
        <Box
            sx={{
                position: "relative",
                width: "100%",
                minHeight: 178,
                borderRadius: 1.5,
                border: `1.5px dashed ${primary}`,
                background: `linear-gradient(135deg, ${alpha(primary, 0.06)} 0%, ${alpha(primary, 0.02)} 100%)`,
                "&:hover": {
                    background: `linear-gradient(135deg, ${alpha(primary, 0.12)} 0%, ${alpha(primary, 0.05)} 100%)`,
                    boxShadow: `0 6px 18px ${alpha(primary, 0.18)}`
                }
            }}
        >
            <ButtonBase
                onClick={onClick}
                focusRipple
                data-ui-bridge="btn.build-new-product"
                data-ui-label={title}
                data-ui-role="button"
                data-ui-group="products"
                data-ui-description="Opens the product creation flow with the agentic assistant"
                sx={{ width: "100%", minHeight: 176, p: 2, display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start", gap: 1.25, textAlign: "left" }}
            >
                <Box
                    sx={{
                        width: 36,
                        height: 36,
                        borderRadius: 1.25,
                        background: `linear-gradient(135deg, ${primary} 0%, ${theme.palette.primary.dark} 100%)`,
                        color: "#fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: `0 4px 10px ${alpha(primary, 0.35)}`
                    }}
                >
                    <AutoAwesomeIcon sx={{ fontSize: 20 }} />
                </Box>
                <Box>
                    <Typography sx={{ fontSize: 14.5, fontWeight: 600, color: theme.palette.text.primary, mb: 0.5 }}>
                        {title}
                    </Typography>
                    <Typography sx={{ fontSize: 12.5, color: theme.palette.text.secondary, lineHeight: 1.55 }}>
                        {description}
                    </Typography>
                </Box>
            </ButtonBase>
        </Box>
    );
};

export default BuildNewProductCard;
